import React from 'react';
import ComingSoon from './ComingSoon';

function PayBills() {
  return <ComingSoon />;
}

export default PayBills;
